import React from 'react';
import { Grid } from '@material-ui/core';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../ReportsScreens/GijgoForReportsScreen';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Vehicles', path: '/', active: true }
];

const TCardVehicles = () => {
    const baseColumns = [
        {
            field: 'cust',
            title: `Customer`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'reg',
            title: `Reg No.`,
            filterable: true,
            sortable: true,
            width: '4%'
        },
        {
            field: 'makeModel',
            title: `Make Model`,
            filterable: true,
            sortable: true,
            width: '7%'
        },
        {
            field: 'description',
            title: `Description`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'engineCapacity',
            title: `Engine Capacity`,
            filterable: true,
            sortable: true,
            width: '6%'
        },
        {
            field: 'dateOfReg',
            title: `Date Of Registration`,
            filterable: true,
            sortable: true,
            width: '7%'
        },
        {
            field: 'branch',
            title: `Branch`,
            filterable: true,
            sortable: true,
            width: '7%'
        },
        {
            field: 'chassisNo',
            title: `Chassis No.`,
            filterable: true,
            sortable: true,
            width: '8%'
        },
        {
            field: 'fuelType',
            title: `Fuel Type`,
            filterable: true,
            sortable: true,
            width: '5%'
        }
    ];

    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res?.data?.list,
                            total: res?.data?.list[0]?.total
                        })}
                        columns={baseColumns}
                        getUrl={`TCardVehicles/TCardVehicles_List`}
                    />
                </Grid>
            </Grid>
        </div>
    );
};
export default TCardVehicles;
